import React from 'react';

const NavIcon = ({ icon: Icon }: { icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>> }) => (
  <Icon height="2rem" fill="none" stroke="white" strokeWidth="2.5px" />
);

export default NavIcon;
